<template>
  <div v-if="currentProfil && currentEvaluation">
    <div class="row mt-4">
      <div class="col-md-12 col-lg-6">
        <button
          type="button"
          class="btn btn-secondary"
          @click.prevent="
            $router
              .push({
                name: 'rh_formation_session_profil_evaluation',
                params: {
                  profilId: currentProfil.id,
                  prov: prov,
                },
              })
              .catch(() => {})
          "
        >
          Liste des évaluations
        </button>
        <button
          type="button"
          class="btn btn-custom-primary ml-4"
          @click.prevent="
            $router
              .push({
                name: 'rh_formation_session_profil_evaluation-create',
                params: {
                  profilId: currentProfil.id,
                  prov: prov,
                },
              })
              .catch(() => {})
          "
        >
          <i class="fas fa-plus"></i>
          Evaluer le participant
        </button>
      </div>
    </div>
    <div class="mt-4 mb-4">
      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="table-rsesponsive" style="background: white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold">
                      Nom de la fiche d'évaluation</span
                    >
                  </td>
                  <td>
                    {{ currentEvaluation.checklist.nom }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="far fa-user text-custom-primary"></i>
                    <span class="font-weight-bold"> Auteur</span>
                  </td>
                  <td class="text-primary">
                    {{
                      currentEvaluation.created_by.prenom
                        ? currentEvaluation.created_by.prenom +
                          ' ' +
                          currentEvaluation.created_by.nom
                        : currentEvaluation.created_by.nom
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="mt-n4 mt-lg-0 col-md-12 col-lg-6">
          <div class="table-rsesponsive" style="background: white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Date d'évaluation</span>
                  </td>
                  <td>
                    {{ currentEvaluation.date }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div v-if="currentEvaluation.item_lists.length > 0" class="mt-n4">
        <div class="row mt-4">
          <div class="col-md-12">
            <table class="table bg-white">
              <thead>
                <tr>
                  <th scope="col" class="col-lg-8">Questions</th>
                  <th scope="col" class="col-lg-4">Appréciations</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in currentEvaluation.item_lists"
                  :key="index"
                >
                  <td>{{ item.libelle }}</td>
                  <td>
                    <b-form-radio-group
                      v-model="item.reponse"
                      :options="reponses"
                      disabled
                    ></b-form-radio-group>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import URL from '@/http/rh/formation/evaluation';
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      prov: this.$route.params.prov,
      currentEvaluation: null,
    };
  },
  computed: {
    ...mapGetters('profilParticipant', ['currentProfil', 'reponses']),
  },
  methods: {
    init() {
      window.axios
        .get(URL.EVALUATION + '/' + this.$route.params.evaluationId)
        .then((resp) => {
          this.currentEvaluation = resp.data.evaluation;
        });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
